import { AppsHydration } from '../models/app/AppsHydration';

export const HYDRATION_KEY = '__ksys-app-hydration__';

export function getHydrationPoint(): AppsHydration {
    if (!(window as any)[HYDRATION_KEY]) {
        (window as any)[HYDRATION_KEY] = {};
    }
    return (window as any)[HYDRATION_KEY];
}



// WEBPACK FOOTER //
// ./src/utils/getHydrationPoint.ts